import React, { useState, useEffect } from "react";
import { PDFDocument } from 'pdf-lib';
import JSZip from 'jszip';
import axios from 'axios';

const MAX_FILESIZE = 100 * 1024 * 1024; // 100 megabytes in bytes
const MAX_FILESIZE_COMPRESS = 10 * 1024 * 1024;
const appInterfaceMergeP = document.getElementsByClassName('AppInterfaceMergeP');
const appInterfaceSplitP = document.getElementsByClassName('AppInterfaceSplitP');
const appInterfaceCompressP = document.getElementsByClassName('AppInterfaceCompressP');
const appInterfacesplitPageNumbers = document.getElementsByClassName('AppInterfacesplitPageNumbers');

let files = [];

function AppInterface() {
    const [isBigScreen, setIsBigScreen] = useState(false);
    const [filesForMerge, setFilesForMerge] = useState([]);
    const [mergeLoading, setMergeLoading] = useState(false);
    const [fileForSplit, setFileForSplit] = useState(null);
    const [splitPageNumbers, setsplitPageNumbers] = useState('');
    const [splitLoading, setSplitLoading] = useState(false);
    const [fileForCompress, setFileForCompress] = useState(null);
    const [compressLoading, setCompressLoading] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 864px)');
        setIsBigScreen(mediaQuery.matches);
        const screenHandler = () => setIsBigScreen(mediaQuery.matches);
        mediaQuery.addListener(screenHandler)
        return () => mediaQuery.removeListener(screenHandler);
    }, []);

    const bigScreen = isBigScreen ? 'AppInterfaceSplitLabelPPC' : 'AppInterfaceSplitLabelPPhone';

    const flushField = (event) => {
        event.target.value = null;
    };

    const handleFilesForMerge = (event) => {
        files = Array.from(event.target.files);

        const validFiles = files.filter((file) => {
            const isValidType = file.type === 'application/pdf';
            const isValidSize = file.size <= MAX_FILESIZE;
            return isValidType && isValidSize;
        });

        if (validFiles.length < 2) {
            alert('Please select at least two PDF files.');
            return;
        }

        if (validFiles.length < files.length) {
            const rejectedFiles = files.filter((file) => !validFiles.includes(file));
            alert('For now, I can only merge PDFs below 100MB. Problematic files: \n\n' + rejectedFiles.map((file) => file.name).join(', '));
            return;
        }

        setFilesForMerge(validFiles);
        appInterfaceMergeP[0].textContent = validFiles.length + " PDF(s) chosen...";

    };

    const mergeReturn = async () => {

        setMergeLoading(true);

        const mergeArrayBuffers = await Promise.all(
            Array.from(filesForMerge).map((fileForMerge) => new Promise((resolve) => {
                const readerForMerge = new FileReader();
                readerForMerge.onload = () => resolve(readerForMerge.result);
                readerForMerge.readAsArrayBuffer(fileForMerge);
                }))
        );

        const pdfsToMerge = await Promise.all(
            mergeArrayBuffers.map((mergeArrayBuffer) => PDFDocument.load(mergeArrayBuffer), { ignoreEncryption: true })
        );

        const mergedPdf = await PDFDocument.create();
        for (const pdfToMerge of pdfsToMerge) {
            const pages = await mergedPdf.copyPages(pdfToMerge, pdfToMerge.getPageIndices());
            for (const page of pages) {
                mergedPdf.addPage(page);
            }
        }

        const mergedPdfBytes = await mergedPdf.save();
        const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
        const mergedPdfUrl = URL.createObjectURL(mergedPdfBlob);
        const mergedPdfLink = document.createElement('a');
        mergedPdfLink.href = mergedPdfUrl;
        mergedPdfLink.download = 'merged.pdf';
        mergedPdfLink.click();

        setFilesForMerge([]);
        appInterfaceMergeP[0].textContent = "Choose PDFs...";

        setMergeLoading(false);
    };

    const handleFileForSplit = (event) => {
        const file = event.target.files[0];
        const fileType = file.type;
        const fileSize = file.size;

        if (fileType !== 'application/pdf') {
            alert('Only PDF files are supported.');
            return;
        }
        if (fileSize > MAX_FILESIZE) {
            alert('For now, I can only split PDFs below 100MB.');
            return;
        };

        setFileForSplit(file);
        appInterfaceSplitP[0].textContent = "PDF chosen...";
    };

    const handlesplitPageNumbers = (event) => {
        setsplitPageNumbers(event.target.value.toString())
    };

    const splitReturn = async () => {
        const checkZeroOne = (pageNumber) => pageNumber <= 1;

        if (!/^[\d, ]+$/.test(splitPageNumbers)) {
            alert('Please specify a page number or page numbers separated by commas in case you want multiple splits.');
            return
        } else if (splitPageNumbers <= 1) {
            alert('Page numbers must be greater than 1');
            return
        } else if (splitPageNumbers.split(',').map(Number).some(checkZeroOne)) {
            alert('Every page number must be greater than 1');
            return
        };

        setSplitLoading(true)

        const splitArrayBuffer = await fileForSplit.arrayBuffer();
        const pdfToSplit = await PDFDocument.load(splitArrayBuffer, { ignoreEncryption: true });
        const splitZip = new JSZip();

        let pageSplitArray = splitPageNumbers.replace(/\s/g, '').split(',').sort();
        pageSplitArray = [...new Set(pageSplitArray)];
        pageSplitArray = pageSplitArray.map(pageSplit => parseInt(pageSplit));
        pageSplitArray = pageSplitArray.map(pageSplit => pageSplit - 1);
        const lastPage = pdfToSplit.getPages().length - 1;
        const lastIndex = pageSplitArray[pageSplitArray.length - 1];
        if (pageSplitArray[0] !== 0) {
            pageSplitArray.unshift(0)
        }
        if (lastIndex >= lastPage) {
            pageSplitArray = pageSplitArray.slice(0, -1);
        }
        pageSplitArray.push(lastPage)

        for (let i = 0; i < pageSplitArray.length - 1; i++) {
            const pageSplitArraySubset = [];
            if (i < 1) {
                for (let j = pageSplitArray[i]; j <= pageSplitArray[i + 1]; j++) {
                    pageSplitArraySubset.push(j);
                }
            } else {
                for (let j = pageSplitArray[i]; j <= pageSplitArray[i + 1]; j++) {
                    pageSplitArraySubset.push(j);
                }
                pageSplitArraySubset.shift(0);
            }

            const pdfSplit = await PDFDocument.create();
            const pdfSplitPages = await pdfSplit.copyPages(pdfToSplit, pageSplitArraySubset);
            pdfSplitPages.forEach((pdfSplitPage) => pdfSplit.addPage(pdfSplitPage));
            const pdfSplitSave = await pdfSplit.save();
            splitZip.file(`split-${pageSplitArraySubset[0] + 1}-${pageSplitArraySubset[pageSplitArraySubset.length - 1] + 1}.pdf`, pdfSplitSave);
        }

        const splittedPdf = await splitZip.generateAsync({ type: 'blob' });
        const splittedPdfUrl = URL.createObjectURL(splittedPdf);
        const splittedPdfLink = document.createElement('a');
        splittedPdfLink.href = splittedPdfUrl;
        splittedPdfLink.download = 'splittedPdf.zip';
        splittedPdfLink.click();

        setFileForSplit(null);
        appInterfaceSplitP[0].textContent = "Choose PDF...";
        setsplitPageNumbers('');
        appInterfacesplitPageNumbers[0].value = "";

        setSplitLoading(false)
    };

    const handleFileForCompress = (event) => {
        const file = event.target.files[0];
        const fileType = file.type;
        const fileSize = file.size;
        if (fileType !== 'application/pdf') {
            alert('Only PDF files are supported.');
            return;
        }
        if (fileSize > MAX_FILESIZE_COMPRESS) {
            alert('For now, I can only compress PDFs below 10MB.');
            return;
        };

        setFileForCompress(file);
        appInterfaceCompressP[0].textContent = "PDF chosen...";

    };

    const compressReturn = async () => {
        if (!fileForCompress) {
            alert('Please select your PDF first.')
            return;
        }

        setCompressLoading(true);

        const formData = new FormData();
        const file = fileForCompress;
        formData.append('file', file);
        let url = 'https://pdfhyper.com/api/compressReturn/';
        await axios.post(url, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
            responseType: 'blob'
        })
        .then((response) => {
            const compressedPdfBlob = new Blob([response.data], {type:'application/pdf'});
            const compressedPdfUrl = URL.createObjectURL(compressedPdfBlob);
            const compressedPdfLink = document.createElement('a');
            compressedPdfLink.href = compressedPdfUrl;
            compressedPdfLink.setAttribute('download', file.name.split('.')[0] + '_compressed.pdf');
            document.body.appendChild(compressedPdfLink);
            compressedPdfLink.click();
        });

        setFileForCompress(null);
        appInterfaceCompressP[0].textContent = "Choose PDF...";

        setCompressLoading(false);
    };

    return (
        <div className="AppInterface">
            <p className="AppInterfaceTitle">
                PDF Hyper
            </p>
            <p className="AppInterfaceText">
                <span style={{ fontWeight: "bold" }}>Hyperfast React App</span> that <span style={{ color: "#19b6f6" }}>merges</span>, <span style={{  color: "#9d56f7" }}>splits</span> or <span style={{  color: "#f3b736" }}>compresses</span> PDFs without internal database storage!
                It’s completely secure, everything happens inside your browser.
            </p>
            <div className="AppInterfaceButtons">
                <div className="AppInterfaceMerge">
                    <label className="AppInterfaceMergeLabel" htmlFor="AppInterfaceMergeInput">
                        <p className="AppInterfaceMergeP">Choose PDFs...</p>
                    </label>
                    <input
                        id="AppInterfaceMergeInput"
                        type="file"
                        accept=".pdf"
                        multiple
                        style={{ display: 'none' }}
                        onChange={handleFilesForMerge}
                        onClick={flushField} />
                    <button className="AppInterfaceMergeButton" onClick={mergeReturn} disabled={ filesForMerge.length <= 1 || mergeLoading }>
                        {mergeLoading ? 'Stand by...' : 'Merge'}
                    </button>
                </div>
                <div className="empty" style={{ marginLeft: "2vw" }} />
                <div className="AppInterfaceSplit">
                    <div className={bigScreen}>
                        <label className="AppInterfaceSplitLabel" htmlFor="AppInterfaceSplitInput" >
                            <p className="AppInterfaceSplitP">Choose PDF...</p>
                        </label>
                        <input
                            className="AppInterfacesplitPageNumbers"
                            onChange={handlesplitPageNumbers}
                            disabled = { !fileForSplit }
                            placeholder={ isBigScreen ? "2, 23..." : "format: 2, 23..." }/>
                        <input
                        id="AppInterfaceSplitInput"
                        type="file"
                        accept=".pdf"
                        style={{ display: 'none' }}
                        onChange={ handleFileForSplit }
                        onClick={ flushField } />
                    </div>
                    <button className="AppInterfaceSplitButton" onClick={splitReturn} disabled={ !fileForSplit || splitLoading }>
                        { splitLoading ? 'Stand by...' : 'Split' }
                    </button>
                </div>
                <div className="empty" style={{ marginLeft: "2vw" }} />
                <div className="AppInterfaceCompress">
                    <label className="AppInterfaceCompressLabel" htmlFor="AppInterfaceCompressInput">
                        <p className="AppInterfaceCompressP">Choose PDF...</p>
                    </label>
                    <input
                        id="AppInterfaceCompressInput"
                        type="file"
                        accept=".pdf"
                        style={{ display: 'none' }}
                        onChange={ handleFileForCompress }
                        onClick={ flushField } />
                    <button className="AppInterfaceCompressButton" onClick={compressReturn} disabled={ !fileForCompress || compressLoading }>
                        {compressLoading ? 'Stand by...' : 'Compress'}
                    </button>
                </div>
            </div>
        </div>
    )

}

export default AppInterface;
